"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function memoize(fn1, fn2) {
    let lastArgs = null;
    let lastAnswer;
    const hasFn2 = typeof fn2 === 'function';
    const realFn = hasFn2 ? fn2 : fn1;
    return function (...args1) {
        let args = hasFn2 ? fn1() : args1;
        if (!lastArgs || lastArgs.length !== args.length || lastArgs.some((it, idx) => it !== args[idx])) {
            lastAnswer = realFn.apply(this, args);
            lastArgs = [...args];
        }
        return lastAnswer;
    };
}
exports.default = memoize;
//# sourceMappingURL=memoize.js.map